<app-page-panel 
        iconNameIonicon="filing"
        pageTitle="Projekt Details"
        [showBackButton]='true'
        [customButton1Title]= "captionButtonNeu()"
        [customButton2Title]= "captionButtonAktuell()"
        [customButton3Title]= "captionButtonAktiv()"
        customButton3Tooltip="Projekt Aktivieren/Inaktivieren"
        [showDetailsButton]="false"
        [showSidepanelButton]="false"
        (backButtonClicked)="BackButtonClicked()"
        (customButton1Clicked)="onBudgetantragNeuClick()"
        (customButton2Clicked)="onBudgetantragClick()"
        (customButton3Clicked)="onProjektAktivToggleClick()"
		[iconMenuButtons]="this.projekt().budgetantragGestellt ? navigationService.iconMenuItems : []"
		[iconMenuOffset]="'budgetantrag/' + this.projekt().budgetantragID"
>


    <div class="flex flex-fill flex-gap-standard flex-col flex-stretch-self">
        <app-element-panel 
            pageTitle="Soll (Aktuell)">
            <dx-data-grid #gridKostengruppeAktuell class="full-height"
                [allowColumnResizing]="true"
                [rowAlternationEnabled]="true"
                [allowColumnReordering]="true"
                [hoverStateEnabled]="true"
                noDataText=""
                [dataSource]="kostengruppenAktuell()"
                (onRowPrepared)="onDataGridRowPrepared($event)">
                <dxi-column dataField="ID" caption="ID" [width]="10" [visible]="false" alignment="left"></dxi-column>
                <dxi-column dataField="kostengruppe" caption="Kostengruppe" alignment="left" minWidth="220"></dxi-column>
                <dxi-column dataField="budget" caption="Budget" [visible]="true" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="auftragswerte" caption="Auftragswerte" [visible]="true" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="istkosten" caption="Ist-Kosten" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="prognose" caption="Prognose" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="restbudget" caption="Restbudget" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxo-group-panel [visible]="false"></dxo-group-panel>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                <dxo-search-panel [visible]="false"></dxo-search-panel>
                <dxo-header-filter [visible]="false" search.enabled="false"></dxo-header-filter>                    
                <dxo-filter-row [visible]="false"></dxo-filter-row>
                <dxo-scrolling mode="virtual" useNative="true" ></dxo-scrolling>
                <dxo-grouping [contextMenuEnabled]="false" [autoExpandAll]="false"></dxo-grouping>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
                <dxo-pager [visible]="false" displayMode="full" [showNavigationButtons]="false" [showPageSizeSelector]="false"></dxo-pager>
                <dxo-paging [pageSize]="5"></dxo-paging>
            </dx-data-grid>
        </app-element-panel>
        <app-element-panel 
            pageTitle="Soll (Budgetverteilung aktuelles gültiges Budget)">
            <dx-data-grid #gridKostengruppePlan class="full-height"
                [allowColumnResizing]="true"
                [rowAlternationEnabled]="true"
                [allowColumnReordering]="true"
                [hoverStateEnabled]="true"
                noDataText=""
                [dataSource]="kostengruppenPlan()"
                (onRowPrepared)="gridService.PrepareSpecialRows($event)">
                <dxi-column dataField="ID" caption="ID" [width]="10" [visible]="false" alignment="left"></dxi-column>
                <dxi-column dataField="kostengruppe" caption="Kostengruppe" alignment="left" minWidth="220"></dxi-column>
                <dxi-column dataField="kosten" caption="Summe" [visible]="true" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="vorjahr" [caption]="gridService.captionVorjahr()" [visible]="true" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr0" [caption]="gridService.captionJahr(0)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr1" [caption]="gridService.captionJahr(1)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr2" [caption]="gridService.captionJahr(2)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr3" [caption]="gridService.captionJahr(3)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr4" [caption]="gridService.captionJahr(4)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr5" [caption]="gridService.captionJahr(5)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr6folgende" [caption]="gridService.captionJahrFF(6)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxo-group-panel [visible]="false"></dxo-group-panel>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                <dxo-search-panel [visible]="false"></dxo-search-panel>
                <dxo-header-filter [visible]="false" search.enabled="false"></dxo-header-filter>                    
                <dxo-filter-row [visible]="false"></dxo-filter-row>
                <dxo-scrolling mode="virtual" useNative="true" ></dxo-scrolling>
                <dxo-grouping [contextMenuEnabled]="false" [autoExpandAll]="false"></dxo-grouping>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
                <dxo-pager [visible]="false" displayMode="full" [showNavigationButtons]="false" [showPageSizeSelector]="false"></dxo-pager>
                <dxo-paging [pageSize]="7"></dxo-paging>
            </dx-data-grid>
        </app-element-panel>
        <app-element-panel 
            pageTitle="Soll - Ist (Abweichung)">
            <dx-data-grid #gridKostengruppeAbweichung class="full-height"
                [allowColumnResizing]="true"
                [rowAlternationEnabled]="true"
                [allowColumnReordering]="true"
                [hoverStateEnabled]="true"
                noDataText=""
                [dataSource]="kostengruppenAbweichung()"
                (onRowPrepared)="onDataGridRowPrepared($event)">
                <dxi-column dataField="ID" caption="ID" [width]="10" [visible]="false" alignment="left"></dxi-column>
                <dxi-column dataField="kostengruppe" caption="Kostengruppe" alignment="left" minWidth="220"></dxi-column>
                <dxi-column dataField="kosten" caption="Summe" [visible]="true" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="vorjahr" [caption]="gridService.captionVorjahr()" [visible]="true" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr0" [caption]="gridService.captionJahr(0)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr1" [caption]="gridService.captionJahr(1)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr2" [caption]="gridService.captionJahr(2)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr3" [caption]="gridService.captionJahr(3)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr4" [caption]="gridService.captionJahr(4)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr5" [caption]="gridService.captionJahr(5)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxi-column dataField="jahr6folgende" [caption]="gridService.captionJahrFF(6)" alignment="right">
                    <dxo-format type="currency" [precision]="0"></dxo-format>
                </dxi-column>
                <dxo-group-panel [visible]="false"></dxo-group-panel>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                <dxo-search-panel [visible]="false"></dxo-search-panel>
                <dxo-header-filter [visible]="false" search.enabled="false"></dxo-header-filter>                    
                <dxo-filter-row [visible]="false"></dxo-filter-row>
                <dxo-scrolling mode="virtual" useNative="true" ></dxo-scrolling>
                <dxo-grouping [contextMenuEnabled]="false" [autoExpandAll]="false"></dxo-grouping>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
                <dxo-pager [visible]="false" displayMode="full" [showNavigationButtons]="false" [showPageSizeSelector]="false"></dxo-pager>
                <dxo-paging [pageSize]="4"></dxo-paging>
            </dx-data-grid>
        </app-element-panel>   
    </div>
</app-page-panel>
<app-projekt-info class="flex flex-fit projekt-info"></app-projekt-info>
